module.exports = __webpack_public_path__ + "img/xingxing.afdb9b4f.png";